var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Listener',{staticClass:"create-page",attrs:{"data-test-id":"apps-create-page"}})}
var staticRenderFns = []

export { render, staticRenderFns }